import StandardAPIService from 'frontcore/data/standards/StandardAPIService'
import { computed, ComputedRef, reactive } from 'vue'
import { defineStore } from 'pinia'
import { PROMISE_STATUS } from 'frontcore/constants'
import { Proxy } from 'frontcore/constants/proxy'
import { StandardMin } from 'frontcore/domain/standards/types'


interface IStandardsState {
  standards: Proxy<StandardMin[]>
}

interface IStandardsStore {
  fetchStandards: (payload?: Record<string, unknown>) => Promise<void>
  standards: ComputedRef<StandardMin[]>
  areStandardsLoaded: ComputedRef<boolean>
  getStandardsByPerimeterIds: (perimeterIds: number[]) => StandardMin[]
}

export const useStandardsStore = defineStore('Standards', (): IStandardsStore => {
  const { fetch } = new StandardAPIService()

  const state = reactive<IStandardsState>({
    standards: {
      data: [],
      promise: Promise.resolve([]),
      promiseStatus: PROMISE_STATUS.notStarted,
    },
  })

  const fetchStandards = async (payload?: Record<string, unknown>) => {
    if (state.standards.promiseStatus === PROMISE_STATUS.notStarted) {
      state.standards.promise = fetch(payload)
      state.standards.promiseStatus = PROMISE_STATUS.pending
    }

    try {
      if (state.standards.data.length === 0) {
        const people = await state.standards.promise
        state.standards.data = people
        state.standards.promiseStatus = PROMISE_STATUS.complete
        
      }
    } catch (e) {
      state.standards.promiseStatus = PROMISE_STATUS.notStarted
    }
  }

  const standards = computed(() => state.standards.data)

  const areStandardsLoaded = computed(() => state.standards.promiseStatus === PROMISE_STATUS.complete)

  const getStandardsByPerimeterIds = (perimeterIds: number[]) => {
    return state.standards.data.filter(standard => standard.perimeters.some((standardPerimeterId) => {
      return perimeterIds.includes(standardPerimeterId)
    }))
  }

  return {
    fetchStandards,
    standards,
    areStandardsLoaded,
    getStandardsByPerimeterIds,
  }
})
